import { autoserialize } from 'cerialize';

export class DonationItem implements IDonationItem {
  @autoserialize id: string;
  @autoserialize type: 'CustomItem' | 'Item';
  @autoserialize source_item_id: string;
  @autoserialize name: string;
  @autoserialize description_preview: string;
  @autoserialize description: string;
  @autoserialize icon_url: string;
  @autoserialize xlarge: number;
  @autoserialize large: number;
  @autoserialize medium: number;
  @autoserialize small: number;
  @autoserialize recycling: number;
  @autoserialize disassembly: number;
  @autoserialize restricted: boolean;
  @autoserialize price: number;

  constructor(payload?: IDonationItem) {
    this.id = payload?.id?.toString();
    this.type = payload?.type;
    this.source_item_id = payload?.source_item_id?.toString();
    this.name = payload?.name;
    this.description = payload?.description;
    this.description_preview = payload?.description_preview;
    this.icon_url = payload?.icon_url;
    this.xlarge = payload?.xlarge;
    this.large = payload?.large;
    this.medium = payload?.medium;
    this.small = payload?.small;
    this.recycling = payload?.recycling;
    this.disassembly = payload?.disassembly;
    this.restricted = payload?.restricted;
    this.price = payload?.price;
  }

  get size(): string {
    if (this.xlarge > 0) return 'xlarge';
    if (this.large > 0) return 'large';
    if (this.medium > 0) return 'medium';
    if (this.small > 0) return 'small';
    return 'Unknown';
  }
}

export interface IDonationItem {
  id: string;
  type?: 'CustomItem' | 'Item';
  source_item_id?: string;
  name?: string;
  description?: string;
  description_preview?: string;
  icon_url?: string;
  size?: string;
  xlarge?: number;
  large?: number;
  medium?: number;
  small?: number;
  recycling?: number;
  disassembly?: number;
  restricted?: boolean;
  price?: number;
  count?: number;
}

export const sizeDescriptions = {
  xlarge: '2+ person lift / special equipment',
  large: '2-person lift',
  medium: '1-person lift',
  small: '1-person lift',
};
